import {
  AloftTime,
  CommentaryGenerationEvent,
  CommentaryGenerationOutcome,
  GenerateCommentaryField,
  generateCommentaryPage,
  schAnalytics,
} from '@aloft/toolkit-shared';

import { z } from 'zod';

type AnalyticsBody = z.infer<typeof schAnalytics>;

export const commentaryGenerationEvent = (
  field: GenerateCommentaryField,
  outcome: CommentaryGenerationOutcome,
): CommentaryGenerationEvent => ({
  field,
  page: generateCommentaryPage(field),
  outcome,
  at: AloftTime.now().toIsoString(),
});

export const withCommentaryGenerationEvent = (
  current: AnalyticsBody | undefined,
  event: CommentaryGenerationEvent,
): AnalyticsBody =>
  schAnalytics.parse({
    version: 1,
    pageTimeMs: current?.pageTimeMs ?? {},
    navigationHistory: current?.navigationHistory ?? [],
    commentaryGenerationEvents: [...(current?.commentaryGenerationEvents ?? []), event],
  });
